import HeadingToolbarView from "./HeadingToolbarView.vue";
import {Heading as HeadingExtension} from "@tiptap/extension-heading";

export default class Heading {

    constructor() {
        this.toolbarView = HeadingToolbarView;
    }

    static create() {
        return new Heading();
    }

    getExtensions() {
        return [HeadingExtension];
    }
}